import {SoundConfigMap} from '@gongxigames/framework/slot/types/SoundConfigMap';

export interface ISoundConfig {
    defaultPriority: SoundConfigMap;
    afterPriority: SoundConfigMap;
}
